"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintbaseWallet = exports.TransactionSuccessEnum = void 0;
const nearAPI = __importStar(require("near-api-js"));
const utils_1 = require("./utils");
const wallet_utils_1 = require("@near-wallet-selector/wallet-utils");
var TransactionSuccessEnum;
(function (TransactionSuccessEnum) {
    TransactionSuccessEnum["MINT"] = "mint";
    TransactionSuccessEnum["TRANSFER"] = "transfer";
    TransactionSuccessEnum["BURN"] = "burn";
    TransactionSuccessEnum["DEPLOY_STORE"] = "deploy-store";
    TransactionSuccessEnum["MAKE_OFFER"] = "make-offer";
    TransactionSuccessEnum["REVOKE_MINTER"] = "revoke-minter";
    TransactionSuccessEnum["ADD_MINTER"] = "add-minter";
    TransactionSuccessEnum["TRANSFER_STORE_OWNERSHIP"] = "transfer-store-ownership";
    TransactionSuccessEnum["AUCTION_LIST"] = "list";
    TransactionSuccessEnum["SIMPLE_SALE_LIST"] = "simple-sale-list";
    TransactionSuccessEnum["UNLIST"] = "unlist";
    TransactionSuccessEnum["TAKE_OFFER"] = "take-offer";
    TransactionSuccessEnum["WITHDRAW_OFFER"] = "withdraw-offer";
})(TransactionSuccessEnum = exports.TransactionSuccessEnum || (exports.TransactionSuccessEnum = {}));
const MintbaseWallet = ({ metadata, options, successUrl, failureUrl, contractId, callback, networkId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const setupWalletState = () => __awaiter(void 0, void 0, void 0, function* () {
        if (typeof window !== undefined) {
            const { connect, WalletConnection, keyStores } = nearAPI;
            const connectionConfig = {
                networkId: networkId,
                keyStore: new keyStores.BrowserLocalStorageKeyStore(),
                nodeUrl: options.network.nodeUrl,
                walletUrl: metadata.walletUrl,
                headers: {},
            };
            const searchParams = new URL(window.location.href);
            const acc = searchParams.searchParams.get('account_id');
            //make near-api-js not throw without lak
            if (acc && !contractId) {
                localStorage.setItem('mintbase-wallet_wallet_auth_key', JSON.stringify({
                    accountId: acc,
                    allKeys: [],
                }));
            }
            const nearConnection = yield connect(connectionConfig);
            const wallet = new WalletConnection(nearConnection, 'mintbase-wallet');
            localStorage.setItem('mintbase-wallet:callback_url', callback);
            return {
                wallet,
            };
        }
        return null;
    });
    const state = yield setupWalletState();
    let activeAccountId;
    const getAccountId = () => activeAccountId;
    const isSignedIn = () => __awaiter(void 0, void 0, void 0, function* () { return !!activeAccountId; });
    const signIn = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const existingAccounts = yield getAccounts();
        const href = encodeURI((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
        if (existingAccounts.length) {
            return existingAccounts;
        }
        yield state.wallet.requestSignIn({
            methodNames: [],
            successUrl: successUrl || href,
            failureUrl: failureUrl || href,
            contractId: contractId,
        });
        return getAccounts();
    });
    const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
        window.localStorage.removeItem('mintbase-wallet:account-data');
        if (state.wallet.isSignedIn()) {
            state.wallet.signOut();
        }
        return;
    });
    const assertValidSigner = (signerId) => {
        if (signerId && signerId !== state.wallet.getAccountId()) {
            throw new Error(`Cannot sign transactions for ${signerId} while signed in as ${activeAccountId}`);
        }
    };
    const signAndSendTransactions = ({ transactions, callbackUrl }) => __awaiter(void 0, void 0, void 0, function* () {
        if (!state.wallet.isSignedIn()) {
            throw new Error('Wallet not signed in');
        }
        //// near-api-js code fails if no lak
        // const { cbUrl } = getCallbackUrl(callbackUrl ?? '');
        // return state.wallet.requestSignTransactions({
        //   transactions: await transformTransactions(transactions),
        //   callbackUrl: cbUrl,
        // });
        const { cbUrl } = (0, utils_1.getCallbackUrl)(callbackUrl !== null && callbackUrl !== void 0 ? callbackUrl : '');
        for (const { signerId } of transactions) {
            assertValidSigner(signerId);
        }
        const stringifiedParam = JSON.stringify(transactions);
        const urlParam = encodeURIComponent(stringifiedParam);
        const newUrl = new URL(`${metadata.walletUrl}/sign-transaction`);
        newUrl.searchParams.set('transactions_data', urlParam);
        newUrl.searchParams.set('callback_url', cbUrl);
        window.location.assign(newUrl.toString());
        return;
    });
    const signAndSendTransaction = ({ receiverId, actions, signerId, callbackUrl, }) => __awaiter(void 0, void 0, void 0, function* () {
        assertValidSigner(signerId);
        if (!receiverId && !contractId) {
            throw new Error('No receiver found to send the transaction to');
        }
        const { cbUrl } = (0, utils_1.getCallbackUrl)(callbackUrl !== null && callbackUrl !== void 0 ? callbackUrl : '');
        const callback = cbUrl || successUrl;
        if (!contractId) {
            const newUrl = new URL(`${metadata.walletUrl}/sign-transaction`);
            const stringifiedParam = JSON.stringify([{ receiverId, signerId, actions }]);
            const urlParam = encodeURIComponent(stringifiedParam);
            newUrl.searchParams.set('transactions_data', urlParam);
            newUrl.searchParams.set('callback_url', callback);
            window.location.assign(newUrl.toString());
        }
        const account = state.wallet.account();
        return account.signAndSendTransaction({
            receiverId: receiverId || contractId,
            actions: actions.map((action) => (0, wallet_utils_1.createAction)(action)),
            walletCallbackUrl: callback,
        });
    });
    const verifyOwner = () => __awaiter(void 0, void 0, void 0, function* () {
        throw new Error(`The verifyOwner method is not supported by ${metadata.name}`);
    });
    const signMessage = () => __awaiter(void 0, void 0, void 0, function* () {
        throw new Error(`The signMessage method is not supported by ${metadata.name}`);
    });
    const getAvailableBalance = () => __awaiter(void 0, void 0, void 0, function* () {
        // const accountId = state.wallet.getAccountId();
        // return await getBalance(accountId);
        throw (`The getAvailableBalance method is not supported by ${metadata.name}`);
    });
    const getAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const accountId = state.wallet.getAccountId();
        const account = state.wallet.account();
        if (!accountId || !account) {
            return [];
        }
        const currentAccount = window.localStorage.getItem('mintbase-wallet:account-creation-data');
        return [
            {
                accountId,
                publicKey: (_b = JSON.parse(currentAccount)) === null || _b === void 0 ? void 0 : _b.devicePublicKey,
            },
        ];
    });
    const switchAccount = (id) => __awaiter(void 0, void 0, void 0, function* () {
        //TODO fix
        setActiveAccountId(id);
        return null;
    });
    const setActiveAccountId = (accountId) => {
        activeAccountId = accountId;
        window.localStorage.setItem('mintbase-wallet:activeAccountId', accountId);
        return null;
    };
    // const transformTransactions = async (
    //   transactions: Array<Optional<Transaction, 'signerId'>>,
    // ): Promise<Array<nearAPI.transactions.Transaction>> => {
    //   const account = state.wallet.account();
    //   const { networkId, signer, provider } = account.connection;
    //   const localKey = await signer.getPublicKey(account.accountId, networkId);
    //   return Promise.all(
    //     transactions.map(async (transaction, index) => {
    //       const actions = transaction.actions.map((action) =>
    //         createAction(action),
    //       );
    //       const accessKey = await account.accessKeyForTransaction(
    //         transaction.receiverId,
    //         actions as any,
    //         localKey,
    //       );
    //       if (!accessKey) {
    //         throw new Error(
    //           `Failed to find matching key for transaction sent to ${transaction.receiverId}`,
    //         );
    //       }
    //       const block = await provider.block({ finality: 'final' });
    //       return nearAPI.transactions.createTransaction(
    //         account.accountId,
    //         nearAPI.utils.PublicKey.from(accessKey.public_key),
    //         transaction.receiverId,
    //         accessKey.access_key.nonce + index + 1,
    //         actions as any,
    //         nearAPI.utils.serialize.base_decode(block.header.hash),
    //       );
    //     }),
    //   );
    // };
    return {
        getAccountId,
        isSignedIn,
        signIn,
        signOut,
        signAndSendTransaction,
        verifyOwner,
        signMessage,
        getAvailableBalance,
        getAccounts,
        switchAccount,
        signAndSendTransactions,
    };
});
exports.MintbaseWallet = MintbaseWallet;
//# sourceMappingURL=mintbase-wallet.js.map